import React from "react";

const NewBoxes = (props) => {

const {newBoxes} = props?.reSyncChainIdResponse

    return (
        <div className="new-boxes border mx-0 rounded-2 row">
            {newBoxes?.length>0 && <div className="cdsn-header col-12 d-flex">
                <span>List of CDSN's </span>
                &nbsp;&nbsp;(<span className="dot dot-active ms-1 me-1"></span> CDSN linked with the hotel.
                <span className="dot dot-inactive ms-2 me-1"></span>CDSN does not have latest software stack or bouquet. Please check Auto Mode report for exact details.)
                </div>}
            {newBoxes?.length?newBoxes?.map((item)=>(
                <div className={`col-4 pt-2 ${item?.ready?"green-color":"red-color"}`} key={item?.cdsn}>{item?.cdsn}</div>
            )):<div className="no-data-available">No Data Available</div>}
        </div>
    )
}

export default NewBoxes;